import { render } from "./multipleSections.vue?vue&type=template&id=4e3a4ec2"
import script from "./multipleSections.vue?vue&type=script&lang=js"
export * from "./multipleSections.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__